module.exports = __webpack_public_path__ + "img/earth-rotating.39f50a97.png";